import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../assets/css/highlights.css";
import { Link } from "react-router-dom";
import { AuthorNameHelper } from "../../helper/AuthorNameHelper";
export default class Highlight extends Component {
  constructor(props) {
    super(props);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }
  render() {
    let length = this.props.data.length;
    let shown =
      window.innerWidth > 817
        ? Math.min(length, 4)
        : window.innerWidth < 657
        ? Math.min(length, 2)
        : Math.min(length, 3);

    const settings = {
      slidesToShow: shown,
      slidesToScroll: shown,
      arrows: false,
      draggable: false,
    };
    return (
      <div className="container-fluid highlights_review_bg">
        {" "}
        {/* highlights_review_bg */}
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div
              className={
                this.props.title === "New Books"
                  ? "container news_padding highlight_border"
                  : "container news_padding"
              }
            >
              {" "}
              {/* highlight container */}
              <div className="row landing_border">
                {" "}
                {/* new books */}
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="pull-left lable_hlight">
                    {this.props.title ? this.props.title : "Highlights"}
                  </div>
                  {length > shown && (
                    <div
                      className="pull-right"
                      style={{ margin: "10px", marginRight: "-18px" }}
                    >
                      <div
                        className="glyphicon glyphicon-menu-left"
                        onClick={this.previous}
                        style={{
                          fontSize: "25px",
                          width: "1.55em",
                          color: "#C0BFBF",
                          cursor: "pointer",
                        }}
                      />
                      &nbsp;&nbsp;
                      <div
                        className="glyphicon glyphicon-menu-right"
                        onClick={this.next}
                        style={{
                          fontSize: "25px",
                          color: "#C0BFBF",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                  )}
                </div>{" "}
                {this.props.data && length !== 0 && (
                  <div className="highlights-container">
                    <Slider ref={(c) => (this.slider = c)} {...settings}>
                      {this.props.data.map((book) => {
                        return (
                          <div
                            key={book.id ? book.id : book.book_id}
                            data-index={1}
                            className="slick-slide slick-active"
                            tabIndex={-1}
                            aria-hidden="false"
                            style={{ outline: "none", width: "160px" }}
                          >
                            <div>
                              <div
                                className="nbs-flexisel-item"
                                tabIndex={-1}
                                style={{
                                  width: "100%",
                                  display: "inline-block",
                                }}
                              >
                                <div className="pull-left slider_img_shadow">
                                  <Link
                                    to={{
                                      pathname: `/bookdetail`,
                                      search: `?book_slug=${book?.book_slug}`,
                                      state: {
                                        crumb: this.props.crumb,
                                      },
                                    }}
                                  >
                                    <img
                                      className="book_cover_image"
                                      src={book.img_path}
                                      alt={book.title}
                                    />
                                  </Link>
                                </div>
                                <div className="highlight_book_title">
                                  <Link
                                    to={{
                                      pathname: `/bookdetail`,
                                      search: `?book_slug=${book?.book_slug}`,
                                      state: { crumb: this.props.crumb },
                                    }}
                                  >
                                    {book.title}
                                  </Link>
                                </div>
                                <div className="highlight_author_name">
                                  {AuthorNameHelper(book.author_details)}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </Slider>
                  </div>
                )}
              </div>
            </div>{" "}
            {/* highlight container */}
          </div>
        </div>
      </div>
    );
  }
}
